<template>
  <div>
    <v-col cols="3" class="d-flex justify-begin mb-2">
      <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
              
              </v-col>
    <div class="contenedor-tabla">
    <div class="scroll-container">
      <table>
        <!-- <caption class="table-header">{{ $t('tabs.gas_prevision_planificacion') }}</caption> -->
        <thead>
          <tr>
            <th class="encabezado_bold">{{ this.$t('gas.horizonte') }}</th>
            <th class="encabezado_bold">{{ this.$t('gas.hora') }}</th>
            <th class="encabezado_bold">{{ this.$t('gas.precio_estimado') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(registro, index) in gas_precios_manual" :key="index" class="tabla-hover">
            <td class="primera_columna">{{ registro.horizonte }}</td>
            <td class="primera_columna"  style="text-align: center !important;">H{{ index + 1 }}</td> 
            <td>{{ formatNumber(registro.valor) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import Papa from "papaparse";
import Swal from "sweetalert2";

const HEADERS_OFICIALES_GAS_PREV = [
  "Horizonte",
  "Hora",
  "Precio Estimado (€ / MWh)"
];

export default {
  props: {
    gas_precios_manual: {
      type: Array,
      required: true
    },
    horizonte:{
      type:Number,
      required:true,
    },
  },
  created() {
    console.log("Recibiendo datos en el hijo:", this.gas_precios_manual.length);
  },
  methods: {
    toCsvDecimalComma(v, fixed = 2) {
    if (v === null || v === undefined || v === '') return '';
    let n = Number(v);
    if (Number.isNaN(n)) n = Number(String(v).replace(',', '.')); 
    if (Number.isNaN(n)) return '';
    return n.toLocaleString('es-ES', {
      minimumFractionDigits: fixed,
      maximumFractionDigits: fixed,
      useGrouping: false,
    });
  },
     exportToCSV() {
    const headers = HEADERS_OFICIALES_GAS_PREV.join(";");

    const rows = (this.gas_precios_manual || []).map((row, index) => {
      const horizonte = this.formatearFechaExport(row.horizonte);
      const hora = `H${index + 1}`;
      const precio = this.toCsvDecimalComma(row.valor, 2);
      return [horizonte, hora, precio].join(";");
    });

    const csvContent = [headers, ...rows].join("\n");
    const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "prevision_precios_gas.csv";
    a.click();
    URL.revokeObjectURL(url);
  },

  importFromCSV() {
    this.$refs.fileInput.click();
  },
  parseNumber(value) {
            if (!value) return 0;
            value = value.trim();

            if (value.includes(',') && !value.includes('.')) {
                value = value.replace(/\./g, '');        
                value = value.replace(',', '.');          
            }

            else if (value.includes(',') && value.includes('.')) {
                
                if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
                value = value.replace(/\./g, '');       
                value = value.replace(',', '.');      
                }
                
                else {
                value = value.replace(/,/g, '');        
                }
            }
            return parseFloat(value);
            },
   handleUpload(event) {
  const file = event.target?.files?.[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon: 'error', title: 'Formato no válido', text: 'Solo se admiten archivos .csv.' });
    event.target.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data = e.target?.result ?? "";

      // ==== HELPERS ====
      

      const normalizeFecha = (fechaStr) => {
        let t = String(fechaStr ?? '').trim().replace('T', ' ');
        // DD/MM/YYYY [H:mm]
        let m = /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{1,2}):(\d{1,2}))?$/.exec(t);
        if (m) {
          const [ , d, M, Y, H='0', min='0'] = m;
          return `${Y}-${M}-${d} ${String(H).padStart(2,'0')}:${String(min).padStart(2,'0')}`;
        }
        // YYYY-MM-DD [H:mm[:ss]]
        m = /^(\d{4}-\d{2}-\d{2})(?:\s+(\d{1,2}):(\d{1,2})(?::\d{1,2})?)?$/.exec(t);
        if (m) {
          const [ , date, H='0', min='0'] = m;
          return `${date} ${String(H).padStart(2,'0')}:${String(min).padStart(2,'0')}`;
        }
        // Solo fecha YYYY-MM-DD
        m = /^(\d{4}-\d{2}-\d{2})$/.exec(t);
        if (m) return `${m[1]} 00:00`;
        return t; 
      };

      const normalizeHorizonte = (h) => normalizeFecha(h);
      const horizonKey = (x) => normalizeHorizonte((x && (x.horizonte ?? x.fecha_hora)) || x || '');

      Papa.parse(data, {
        delimiter: ";",
        skipEmptyLines: true,
        header: true,
        complete: (result) => {
          
          let rows = (result.data || []).filter(r => Object.values(r).some(v => String(v ?? '').trim() !== ''));
          if (!rows.length) throw new Error("El CSV está vacío.");

          const HEADERS = HEADERS_OFICIALES_GAS_PREV; 
          let headers = (result.meta?.fields ?? Object.keys(rows[0] || []))
            .map((h, i) => (i === 0 ? String(h).replace(/^\uFEFF/, '') : String(h)).trim());

          const faltantes = HEADERS.filter(h => !headers.includes(h));
          const extras = headers.filter(h => !HEADERS.includes(h)).map(x => String(x).trim()).filter(Boolean);
          const desordenadas = [];
          HEADERS.forEach((h, i) => { if (headers[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`); });

          if (faltantes.length || extras.length || desordenadas.length) {
            const seccion = (t, arr) => arr.length ? `<h4 style="margin:6px 0 2px 0;">${t}</h4><ul style="margin:0 0 8px 18px;">${arr.map(x=>`<li>${x}</li>`).join('')}</ul>` : '';
            const html = `<div style="text-align:left;">${seccion('❌ Faltan', faltantes)}${seccion('⚠️ Sobran', extras)}${seccion('🔄 Desordenadas', desordenadas)}</div>`;
            Swal.fire({ icon: 'error', title: 'Encabezados incorrectos', html, width: 800 });
            event.target.value = '';
            return;
          }

          // ==== Validación de celdas obligatorias ====
          const COL_H = "Horizonte";
          const COL_HORA = "Hora";
          const COL_PRECIO = "Precio Estimado (€ / MWh)";
          const faltasPorCol = { [COL_H]: [], [COL_HORA]: [], [COL_PRECIO]: [] };

          rows.forEach((r, idx) => {
            const line = idx + 2;
            const h = String(r[COL_H] ?? '').trim();
            const hora = String(r[COL_HORA] ?? '').trim();
            const precioRaw = r[COL_PRECIO];

            if (!h) faltasPorCol[COL_H].push(line);
            if (!hora) faltasPorCol[COL_HORA].push(line);

            if (precioRaw === undefined || precioRaw === null || String(precioRaw).trim() === '') {
              faltasPorCol[COL_PRECIO].push(line);
            } else {
              const n = this.parseNumber(String(precioRaw));
              if (!Number.isFinite(n)) faltasPorCol[COL_PRECIO].push(line);
            }
          });

          const columnasConFaltas = Object.entries(faltasPorCol).filter(([, arr]) => arr.length);
          if (columnasConFaltas.length) {
            const html = `<div style="text-align:left;">${
              columnasConFaltas.map(([col, arr]) => `• <b>${col}</b>: líneas <b>${arr.join(', ')}</b>`).join('<br>')
            }</div>`;
            Swal.fire({ icon: 'error', title: 'Faltan datos obligatorios', html });
            event.target.value = '';
            return;
          }

          // ==== Construir mapa CSV  ====
          const valorPorHorizonte = new Map();
          const negativos = [];
          rows.forEach((row) => {
          const key = normalizeFecha(this.formatearFechaImport(String(row[COL_H]).trim()));

          const valor = this.parseNumber(String(row[COL_PRECIO]));

          if (!Number.isFinite(valor)) {
            throw new Error(`Valor no numérico en '${COL_PRECIO}' para ${row[COL_H]} ${row[COL_HORA]}.`);
          }

          if (valor < 0) {
            negativos.push(`${row[COL_H]} ${row[COL_HORA]} = ${valor}`);
          }

          valorPorHorizonte.set(key, valor);
        });

          // ==== Emparejar con datos existentes por horizonte  ====
          const existentesCanon = this.gas_precios_manual.map(it => horizonKey(it));
          const faltanEnCsv = [];
          let actualizados = 0;

          const nuevosDatos = this.gas_precios_manual.map((it, i) => {
            const key = existentesCanon[i];
            if (valorPorHorizonte.has(key)) {
              actualizados++;
              return { ...it, valor: valorPorHorizonte.get(key) };
            } else {
              faltanEnCsv.push(key);
              return it;
            }
          });

          this.$emit("update:gas_precios_manual", nuevosDatos);

          // ==== Mensajes  ====
          const avisos = [];
          
          if (negativos.length) {
            avisos.push(`Valores negativos detectados (primeros 10):<br>${negativos.slice(0,10).join('<br>')}${negativos.length>10?'…':''}`);
          }

          if (avisos.length) {
            Swal.fire({
              icon: 'warning',
              title: 'Importación completada con avisos',
              html: `${actualizados} registros actualizados.<br>${avisos.join('<br><br>')}`
            });
          } else {
            Swal.fire({ icon: 'success', title: 'Importación correcta', text: `${actualizados} registros actualizados.` });
          }
        },
        error: () => { throw new Error('No se pudo leer el CSV.'); }
      });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error al importar', text: err?.message ?? 'Archivo no válido.' });
    } finally {
      event.target.value = '';
    }
  };

  reader.readAsText(file, 'utf-8');
},


  // Formatear fecha en la exportación para que siempre sea YYYY-MM-DD HH:MM
  formatearFechaExport(fechaStr) {
    try {
      let fecha = new Date(fechaStr);
      let anio = fecha.getFullYear();
      let mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
      let dia = fecha.getDate().toString().padStart(2, "0");
      let hora = fecha.getHours().toString().padStart(2, "0");
      let minutos = fecha.getMinutes().toString().padStart(2, "0");
      return `${anio}-${mes}-${dia} ${hora}:${minutos}`;
    } catch (error) {
      console.error("Error al formatear la fecha para exportación:", fechaStr);
      return fechaStr; // Si hay error, devolver la original
    }
  },

  // Formatear fecha en la importación para asegurar que Vue la maneja bien
  formatearFechaImport(fechaStr) {
    try {
      if (fechaStr.includes("/")) {
        // Si viene en formato DD/MM/YYYY H:mm, convertirlo
        let [dia, mes, anioHora] = fechaStr.split("/");
        let [anio, horaMin] = anioHora.split(" ");
        return `${anio}-${mes}-${dia} ${horaMin}`;
      }
      return fechaStr; // Si ya está en el formato correcto, no tocarlo
    } catch (error) {
      console.error("Error al formatear la fecha para importación:", fechaStr);
      return fechaStr;
    }
  },
  formatNumber(v) {
  if (v === null || v === undefined || v === '') return '';
  const n = Number(v);
  if (Number.isNaN(n)) return v; 
  return n.toLocaleString('es-ES', {
    minimumFractionDigits: 2,   
    maximumFractionDigits: 6
  });
}
  }
};
</script>
<style scoped>
.scroll-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 200px); 
  overflow-x: auto;
  overflow-y: auto;
  /* border: 1px solid #D9D9D9; */
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}
.contenedor-tabla {
  max-width: 600px;
 /*  margin: auto; */
}
table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}
thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }

.table-header {
  position: sticky;
  top: 0;
  z-index: 15;
  font-size: 1.5em;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  color: white;
  background-color: #006699;
  padding: 10px;
}

/* th {
  border: 2px solid #D9D9D9;
  background-color: white;
  color: #024e74;
  padding: 10px;
  font-weight: bold;
  font-size: large;
} */

.primera_columna {
  background-color: white;
}
.encabezado_bold{
        font-size: 14px;
      }

/* td {
  font-weight: bold;
  color: #024e74;
  border: 2px solid #D9D9D9;
  padding: 10px;
  background-color: #F2F2F2;
} */
</style>
